/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for registration endpoint.
 * @export
 * @interface APIRegister
 */
export interface APIRegister {
    /**
     * 
     * @type {string}
     * @memberof APIRegister
     */
    email: string;
}

/**
 * Check if a given object implements the APIRegister interface.
 */
export function instanceOfAPIRegister(value: object): value is APIRegister {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIRegisterFromJSON(json: any): APIRegister {
    return APIRegisterFromJSONTyped(json, false);
}

export function APIRegisterFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRegister {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function APIRegisterToJSON(value?: APIRegister | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

